import HttpClient from "../utils/HttpClient"

export const apiClient = HttpClient({
  baseURL: "https://graph.microsoft.com/v1.0/",
})
